import { FC, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import styles from '../../assets/css/header.module.scss';
import {
  AppHandoffRoute,
  PersonalizationRoute,
  PreviewInsoleRoute,
  ScanInProgressRoute,
} from '../../constants/routes';
import { withQueryParams } from '../../helpers/navigation';

import superfeetLogo from '../../assets/images/superfeet-logo.svg';
import { trackExitPersonalizedInsole } from '../../services/google_analytics';

const Header: FC = () => {
  const [searchParams] = useSearchParams();
  const productHandle = searchParams.get('product_handle');

  const productPageRoute = window.location.origin + '/products/' + productHandle;

  return (
    <header className={styles.header}>
      <div className={styles.logoContainer}>
        <a href={productPageRoute} onClick={() => trackExitPersonalizedInsole()}>
          <img src={superfeetLogo} alt="Superfeet Logo" className={styles.logo} />
        </a>
      </div>
      {import.meta.env.VITE_STUB_DATA_FOR_DEVELOPMENT === 'true' && (
        <nav className={styles.globalHeaderNav}>
          <span>&#9776;</span>
          <ul>
            <li>
              <Link to={withQueryParams(AppHandoffRoute, searchParams)}>App Handoff</Link>
            </li>
            <li>
              <Link to={withQueryParams(ScanInProgressRoute, searchParams)}>Scan In Progress</Link>
            </li>
            <li>
              <Link to={withQueryParams(PreviewInsoleRoute, searchParams)}>Preview Insole</Link>
            </li>
            <li>
              <Link to={withQueryParams(PersonalizationRoute, searchParams)}>Personalization</Link>
            </li>
          </ul>
        </nav>
      )}
      <a className={styles.headerCloseButton} aria-label="Close Header" href={productPageRoute} onClick={() => trackExitPersonalizedInsole()}>
        <i className="icon-close"></i>
      </a>
    </header>
  );
};

export default Header;
